import styled from '@emotion/styled';

import Button from 'components/field/Button';

import { Breakpoints } from 'utils/const.styles';

export const Container = styled.div`
	flex-direction: column;
	flex-wrap: wrap;
	align-items: center;
	justify-content: center;
`;
export const IconContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 1rem;
`;

export const BlockDiv = styled.div`
	display: flex;
	justify-content: center;
	flex-wrap: wrap-reverse;
`;
export const HeadText = styled.div`
	font-size: var(--paragraph1-font-size);
	font-weight: 700;
	width: 70%;
	text-align: center;
	color: var(--black);
	margin: var(--margin-3) auto;
`;
export const BodyText = styled.div`
	font-size: var(--paragraph3-font-size);
	font-weight: 500;
	margin: 0.5rem 0;
	text-align: center;
	color: var(--content-2);
`;
export const ButtonContainer = styled.div`
	/* width: 30%; */
	display: inline-block;
	margin: var(--margin-4) var(--margin-1);

	@media ${Breakpoints.mobile} {
		margin: var(--margin-2) var(--margin-1);
	}
`;

export const SmallButton = styled(Button)`
	min-width: 8rem;
`;
